import {
  LOGOUT,
  PAGE_PERMISSIONS_ERROR,
  SET_PAGE_PERMISSIONS,
} from "../actions/constants";

const initialState = { loading: true, roles: [], pageKeys: [], error: false };

export default function permissionsReducer(state = initialState, action) {
  switch (action.type) {
    case SET_PAGE_PERMISSIONS:
      return {
        loading: false,
        error: false,
        roles: action.payload.roles || [],
        pageKeys: action.payload.pageKeys || [],
      };
    case PAGE_PERMISSIONS_ERROR:
      return { ...state, loading: false, error: true };
    case LOGOUT:
      return initialState;
    default:
      return state;
  }
}
